import React from "react";
import { CompositeDecorator } from "draft-js";
import store from "../../store";

import handleDynamicField from "./handleDynamicField";

const findSpotlight = (contentBlock, callback) => {
  const blockKey = contentBlock.getKey();
  const { spotlightEntities, spotlightEntitiesActive } =
    store.getState().MetalensStore;
  if (spotlightEntitiesActive) {
    const text = contentBlock.getText();
    spotlightEntities.forEach(se => {
      if (se.id === blockKey && text.indexOf(se.text, se.start) === se.start) {
        callback(se.start, se.end);
      }
    });
  }
};

const handleSpotlight = props => {
  const { spotlightEntities } = store.getState().MetalensStore;
  let index = -1;
  if (spotlightEntities && props.decoratedText) {
    index = spotlightEntities.findIndex(
      item => item.text === props.decoratedText,
    );
  }
  if (index === -1) {
    index = "";
  } else {
    index = `${index + 1}`;
  }

  return (
    <span className="spotlight-highlight">
      <span className="spotlight-bubble">
        <span className="spotlight-bubble-content">{index}</span>
      </span>
      {props.children}
    </span>
  );
};

const findMetaData = (contentBlock, callback) => {
  // redux to meta here
  const blockKey = contentBlock.getKey();
  const { blockMetadataMap, active } = store.getState().MetalensStore;

  if (
    active &&
    blockMetadataMap &&
    blockMetadataMap[blockKey] &&
    blockMetadataMap[blockKey].length
  ) {
    const mentions = blockMetadataMap[blockKey];
    const text = contentBlock.getText();
    mentions.forEach(mention => {
      if (
        mention.component_data &&
        mention.component_data.blockId === blockKey
      ) {
        if (text.indexOf(mention.text, mention.start) === mention.start) {
          callback(mention.start, mention.end);
        }
      }
    });
  }
};

const handleMetaData = props => {
  let id = "";
  if (
    props.children &&
    props.children.length &&
    props.children[0].props &&
    props.children[0].props.block
  ) {
    id = `${props.children[0].props.block.getKey()}-meta-${
      props.children[0].props.start
    }`;
  }
  return (
    <span id={id} className="document-meta-highlight">
      {props.children}
    </span>
  );
};

const findDynamicEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "DYNAMICFIELD"
    );
  }, callback);
};

const findHighlightNotes = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "NOTES"
    );
  }, callback);
};

const handleHighlightNotes = props => {
  const data = props.contentState.getEntity(props.entityKey).getData();
  let className = "document-highlight";
  const isShared =
    typeof window !== "undefined" &&
    window.location.pathname.includes("/shared/documents/");
  if (isShared) {
    const { documentNotes } = store.getState().NotesStore;
    const notedata = documentNotes.find(note => note.anchor.id === data.id);
    if (!notedata) className = "";
  }

  return (
    <span id={`document_highlight_id_${data.id}`} className={`${className}`}>
      {props.children}
    </span>
  );
};

const findComments = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "COMMENTS"
    );
  }, callback);
};

const handleComments = props => (
  // const data = props.contentState.getEntity(props.entityKey).getData();
  <span className="document-comments">{props.children}</span>
);

// Linkify Draft State
function findLinkEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "LINK"
    );
  }, callback);
}

const handleLinks = props => {
  const { url } = props.contentState.getEntity(props.entityKey).getData();
  let linkColor = {};
  if (
    props.children[0] &&
    props.children[0].props &&
    props.children[0].props.styleSet
  ) {
    const styles = Array.from(props.children[0].props.styleSet);
    if (styles && styles.length > 0) {
      const fontStyle = styles.find(style =>
        style && typeof style === "string"
          ? style.startsWith("FONTCOLOR")
          : null,
      );
      if (fontStyle) {
        linkColor = {
          color: `#${fontStyle.split("_")[1]}`,
        };
      }
    }
  }
  return (
    <a
      href={url}
      rel="noopener noreferrer"
      target="_blank"
      className="document-links"
      data-test="hyperlink-url"
      style={linkColor}>
      {props.children}
    </a>
  );
};

const getCompositeDecorator = (
  updateFormRowDataField,
  updateDynamicFieldsInDoc,
  updateDynamicFieldsInMasterDoc,
  updateEditorStateInSectionForClauseOptions,
  executeCommand,
  currentUser,
  sectionId,
) => {
  const compositeDecorator = new CompositeDecorator([
    {
      strategy: findDynamicEntities,
      component: handleDynamicField,
      // following props are being used only to handle the checkbox field updates
      props: {
        updateFormRowDataField,
        updateDynamicFieldsInDoc,
        updateDynamicFieldsInMasterDoc,
        updateEditorStateInSectionForClauseOptions,
        executeCommand,
        currentUser,
        sectionId,
      },
    },
    {
      strategy: findHighlightNotes,
      component: handleHighlightNotes,
    },
    {
      strategy: findLinkEntities,
      component: handleLinks,
    },
    {
      strategy: findComments,
      component: handleComments,
    },
    {
      strategy: findSpotlight,
      component: handleSpotlight,
    },
    {
      strategy: findMetaData,
      component: handleMetaData,
    },
  ]);
  return compositeDecorator;
};

export default getCompositeDecorator;
